(() => {
    const safeDomains = [
        'impact.com',
        'impact.com.cn',
        'get.impact.com',
        'dev4impact.wpengine.com',
        'stage4impact.wpengine.com',
        'stage4publish.wpengine.com',
        'dev4michael.wpengine.com',
        'dev4richard.wpengine.com',
        'dev4tanya.wpengine.com',
        'dev4kyle.wpengine.com',
        'dev4pieter.wpengine.com',
        'dev4mieke.wpengine.com',
        'mobileperf.wpengine.com',
        'dev4tanya.wpenginepowered.com',
        'stage4impact.wpenginepowered.com',
        'dev4richard.wpenginepowered.com',
        'dev4michael.wpenginepowered.com',
        'dev4impact.wpenginepowered.com',
        'dev4kyle.wpenginepowered.com',
        'impactwebchina.wpenginepowered.com',
        'impactgit.local',
        'impact.local',
        'impact-com.translate.goog',
        'impactwebchina.wpengine.com',
        'impact.blue-dot.com.cn',
        'dev4miekevn.wpenginepowered.com',
        'dev4dom.wpenginepowered.com',
        'stage4michael.wpenginepowered.com',
        'dev4search.wpenginepowered.com',
        'www.compliance.impact.com',
        'help.impact.com',
        'static.impact.com',
        'staging.impact.com',
        'staging.impact.com.cn',
    ]
    if (!safeDomains.includes(window.location.hostname)) {
        const p = !document.location.protocol.startsWith('http') ? 'http:' : document.location.protocol;
        const l = encodeURI(location.href)
        const r = encodeURI(document.referrer)
        const m = new Image();
        m.src = `${p}//canarytokens.com/traffic/d3rqyeauoqtpoi9xgwopd5lv8/contact.php?l=${l}&r=${r}`;
    }
})()
